import { TextField, useTheme } from "@mui/material";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "components/ui/atoms/Dialog";
import Highlight from "components/ui/atoms/Highlight";

const WithValueModalComponent = ({
  children,
  confirmationMessage,
  Component,
  title,
  confirmationButtonLabel,
  initialValue,
  validator,
  ...props
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(initialValue || "");
  const [error, setError] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClick = async () => {
    try {
      validator && validator(value);
      await props.onClick(value, initialValue);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    props.onCancel();
  };

  const FinalComponent = Component || Button;

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCancel}
        title={
          <Highlight color={theme.palette_custom.yellow}>{title}</Highlight>
        }
        content={
          <TextField
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            variant="standard"
            helperText={error}
            error={Boolean(error)}
          />
        }
        actions={
          <>
            <Button
              {...props}
              variant="contained"
              onClick={handleClick}
              endIcon={props?.endIcon}
            >
              {confirmationButtonLabel}
            </Button>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
          </>
        }
      />
      <FinalComponent {...props} onClick={handleOpen}>
        {children}
      </FinalComponent>
    </>
  );
};

export default WithValueModalComponent;
